"use client";

import React from "react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { updateTripDetail } from "@/lib/actions/trip.actions";
import { Loader2 } from "lucide-react";
import { useRouter } from "next/navigation";
import CancelPopover from "./CancelPopover";

const CancelAndRateBox = ({
  course_token,
  trip_display,
  box_with_cancel,
  box_with_rate,
  rating
}: {
  course_token: string;
  trip_display: string;
  box_with_cancel: boolean;
  box_with_rate: boolean
  rating:number
}) => {

  const [isLoading, setIsLoading] = React.useState(false);
  const router = useRouter();

  // no taxi allocated: annulation direct
  // avec taxi alloued: annulation avec confirmation

  const onClickPreallocatedCancel = async () => {
    setIsLoading(true);
    try {
      const action = "cancel_taxi";
      await updateTripDetail({ action, course_token, data:{reason:'0'} });
      toast.success(`Commande annulée`);
    } catch (error) {
      console.error("onClickPreallocatedCancel", error);
    } finally {
      setIsLoading(false);
      router.refresh();
    }
  };

  if (trip_display == "NOTHING") {
    return (<div></div>);
  }

  if (trip_display == "BUTTON") {
    return (
      <div>
        <Button
          className="view-all-btn"
          disabled={isLoading}
          onClick={onClickPreallocatedCancel}>
          {isLoading ? (
            <div className="flex">
              <Loader2 size={20} className="animate-spin" /> &nbsp; Annulation
            </div>
          ) : (
            "Annuler"
          )}
        </Button>
      </div>
    );
  }

  if (trip_display == "BOX") {
    return (
      <CancelPopover course_token={course_token} 
        box_with_cancel={box_with_cancel}
        box_with_rate={box_with_rate}
        rating={rating}/>
    );
  }
  
  return (<div></div>);

}

export default CancelAndRateBox;
